<template>
    <div>
        <van-empty description="正在加载。。。" />
    </div>
</template>

<script lang="ts">
  import {defineComponent, reactive,onMounted} from 'vue';
  import { useRouter,useRoute } from 'vue-router';

  export default defineComponent({
    setup() {
      const data = reactive({});
      const router = useRouter();
      const route = useRoute();

      onMounted(()=>{
        router.push({
          name:route.query.name as string,
          query:{
            id:route.query.id,
            code:route.query.code
          },
          replace:true
        });
      });

      return {
        data
      };
    }
  });
</script>

<style lang="scss" scoped>

</style>
